const main = "#141f38"
const secondary = "#ffffff"

const levelColors = {
    Etapa_roja: "red",
    Etapa_naranja: "orange",
    Etapa_verde: "#017f36",
    Clase_D: "#ffdf00", 
    Clase_C: "blue",
    Clase_B: "purple",
    Clase_A: "blue",
    Profesional: "black"
}

export {
    main,
    secondary,
    levelColors
}